var _rect, _rect2, _ellipse, _rect3, _rect4, _rect5, _ellipse2, _rect6, _rect7, _rect8, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcHousingProtectServiceBodyMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 114,
    viewBox: "0 0 140 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.6719,
    y: 43.9951,
    width: 89.9078,
    height: 16.8259,
    rx: 8.41293,
    transform: "rotate(-13.259 19.6719 43.9951)",
    fill: "#EEC2B9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.808594,
    y: 59.3174,
    width: 78.6561,
    height: 23.5119,
    rx: 11.756,
    transform: "rotate(-48.259 0.808594 59.3174)",
    fill: "#EEC2B9"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.1017,
    cy: 72.782,
    rx: 33.6517,
    ry: 35.755,
    transform: "rotate(-13.259 35.1017 72.782)",
    fill: "#EEC2B9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22.1016,
    y: 54.2998,
    width: 52.5266,
    height: 56.718,
    rx: 13.6,
    transform: "rotate(-13.259 22.1016 54.2998)",
    fill: "#EEC2B9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.873,
    y: 39.1943,
    width: 89.9078,
    height: 16.8259,
    rx: 8.41293,
    transform: "rotate(-13.259 18.873 39.1943)",
    fill: "#FFDCD5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.0078125,
    y: 54.5176,
    width: 78.6561,
    height: 23.5119,
    rx: 11.756,
    transform: "rotate(-48.259 0.0078125 54.5176)",
    fill: "#FFDCD5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.3009,
    cy: 67.9812,
    rx: 33.6517,
    ry: 35.755,
    transform: "rotate(-13.259 34.3009 67.9812)",
    fill: "#FFDCD5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 21.3027,
    y: 49.5,
    width: 52.5266,
    height: 56.718,
    rx: 13.6,
    transform: "rotate(-13.259 21.3027 49.5)",
    fill: "#FFDCD5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 94.7754,
    y: 76.1309,
    width: 44.705,
    height: 37.3969,
    rx: 1.6,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 114.359,
    y: 90.1904,
    width: 5.53408,
    height: 15.6588,
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 117.13,
    cy: 90.1904,
    r: 6.38179,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.928 80.942V62.2576C103.928 58.2812 107.151 55.0576 111.128 55.0576H123.127C127.103 55.0576 130.327 58.2812 130.327 62.2576V80.942",
    stroke: "#D9D9D9",
    strokeWidth: 5.6,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHousingProtectServiceBodyMobile);
export default __webpack_public_path__ + "static/media/IcHousingProtectServiceBodyMobile.d867a627f41f9f89e40c3a44553a3a86.svg";
export { ForwardRef as ReactComponent };